import { render, staticRenderFns } from "./systemBackups.vue?vue&type=template&id=1c5fc345"
import script from "./systemBackups.vue?vue&type=script&lang=js"
export * from "./systemBackups.vue?vue&type=script&lang=js"
import style0 from "./systemBackups.vue?vue&type=style&index=0&id=1c5fc345&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports